import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { ClickAwayListener, IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, Paper, Popper, } from '@mui/material';
import { AccountTree, AddTask, EditRounded, HelpOutline, History, Map, MoneyOff, Tune, } from '@mui/icons-material';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import branding from 'shared/app/model/branding';
import Polygon from 'console/billing/account-tariff/icons/polygon.svg';
import { customIconsPackageTitle } from 'shared/hooks/helpers';
const freeBenefits = [
    {
        title: 'Основной функционал',
        icon: _jsx(Tune, { color: "inherit" }),
    },
    {
        title: '3 месяца хранения данных',
        icon: _jsx(History, { color: "secondary" }),
    },
    {
        title: 'Бесплатно',
        icon: _jsx(MoneyOff, { color: "success" }),
    },
];
export function TariffFreeBenefits() {
    return (_jsx(List, { children: freeBenefits.map(({ title, icon }, i) => (_jsxs(ListItem, { children: [_jsx(ListItemIcon, { children: icon }), _jsx(ListItemText, { primary: title })] }, i))) }));
}
const proBenefits = [
    {
        title: 'Индивидуальные названия устройств',
        icon: _jsx(EditRounded, { color: "inherit" }),
        hint: 'Можно задавать названия устройств в настройках совместного доступа,' +
            ' видимые только Вам',
    },
    {
        title: 'История конфигураций',
        icon: _jsx(ManageHistoryIcon, { color: "error" }),
        hint: 'Все загруженные конфигурации на прибор будут отображены в истории ' +
            'с результатами сравнения и возможностью скачать или применить выбранную конфигурацию.',
    },
    {
        title: '2 года хранения данных',
        icon: _jsx(History, { color: "success" }),
        hint: `Графики, история поездок и события будут храниться в облаке
         ${branding.name} в течение двух лет`,
    },
    {
        title: 'Сводная карта объектов',
        icon: _jsx(Map, { color: "inherit" }),
        hint: 'Все стационарные и мобильные объекты будут отображены' +
            ' на единой карте с указанием их названия,' +
            ' модели и статуса (норма, авария, не на связи)',
    },
    {
        title: 'Группировка устройств',
        icon: _jsx(AccountTree, { color: "primary" }),
        hint: 'Устройства в списке можно объединять в группы для удобства' +
            ' навигации. Группы могут быть вложенными.',
    },
    {
        title: 'Геозоны',
        icon: _jsx(Polygon, {}),
        hint: 'Для автомобильных приборов: можно задавать области на карте' +
            ' и получать события о въезде, выезде, а также превышении' +
            ' скорости в геозоне',
    },
    {
        title: `${customIconsPackageTitle}`,
        icon: _jsx(AddTask, { color: "warning" }),
        hint: 'К выбору доступно большее количество значков, а также можно загрузить собственные.',
    },
];
export function TariffZontProBenefits() {
    const [hint, setHint] = useState(null);
    const [showHint, setShowHint] = useState(false);
    const [hintAnchor, setHintAnchor] = useState(null);
    function onHintClick(hint, anchor) {
        setHint(hint);
        setHintAnchor(anchor);
        setShowHint(true);
    }
    const onCloseHint = useCallback(() => setShowHint(false), [setShowHint]);
    return (_jsxs(_Fragment, { children: [_jsx(List, { children: proBenefits.map((benefit, i) => (_jsxs(ListItem, { children: [_jsx(ListItemIcon, { children: benefit.icon }), _jsx(ListItemText, { primary: benefit.title }), _jsx(ListItemSecondaryAction, { children: _jsx(IconButton, { size: "small", onClick: (event) => onHintClick(benefit.hint, event.currentTarget), children: _jsx(HelpOutline, { fontSize: "small" }) }) })] }, i))) }), _jsx(Popper, { open: showHint, anchorEl: hintAnchor, placement: "top", style: { zIndex: 1500 }, children: _jsx(ClickAwayListener, { onClickAway: onCloseHint, touchEvent: false, children: _jsx(Paper, { sx: { p: 2, maxWidth: 350 }, elevation: 3, children: hint }) }) })] }));
}
